// extracted by mini-css-extract-plugin
export default {"mainCanvas":"SiteDemo_mainCanvas__bgYuR"};